<label class="switch">
  <input type="checkbox" [formControl]="switchFormControl">
  <span class="slider"></span>
</label>



// WEBPACK FOOTER //
// ./src/app/shared/toggle-switch/toggle-switch.component.html